import React from "react";
import ImageCard from "../ImageCard";
import ImageDropper from "../ImageDropper";
import _ from "lodash";

const SingleImageUploader = ({ file = {}, onFileSelected = (file) => { }, onFileChanged = (url) => { } }) => {
    return (
        <div className="overflow-auto">
            <div className="flex justify-center p-2 min-w-max">
                <div className="w-40 h-40">
                    {!_.isEmpty(file) ?
                        <div className="border border-dashed border-indigo-600 rounded-md cursor-pointer hover:bg-gray-50 overflow-hidden">
                            <ImageCard
                                file={file}
                                index={0}
                                onRemove={(file, index) => { onFileChanged(null) }}
                            />
                        </div>
                        :
                        <ImageDropper
                            onFilesSelected={(files) => { onFileSelected(files[0]) }}
                            isMultiple={false}
                        />
                    }
                </div>

            </div>
        </div>
    )
}

export default SingleImageUploader;
